import { enumMatchSubs } from "../constants";
import { QRule } from "./QRule";

export class QAssistantRule extends QRule {
  constructor() {
    //  this.fUseRule = false;
    super();
  }

  InitAssistantRule(ruleType) {
    this.InitRule(enumMatchSubs.matchonly, 0, false);
    this.SetXMLElementName(ruleType);
  }

  NewObject() {
    return new QAssistantRule();
  }
}
